import React from 'react';
import PropTypes from 'prop-types';

import { logUncaught } from 'utils/log';
import ErrorPage from 'components/ErrorPage';
import ErrorBoundary from 'components/ErrorBoundary';
import Head from './Head';

const App = ({ children }) => (
  <ErrorBoundary errorComponent={<ErrorPage />} logError={logUncaught}>
    <Head />
    {React.Children.toArray(children)}
  </ErrorBoundary>
);

App.propTypes = {
  children: PropTypes.element.isRequired,
};

export default App;
